module.exports = __webpack_public_path__ + "media/images/Favicon-SWB-6595f613ced16c677c56f69e3022fa51.png";